export const peopleURL = "https://swapi.dev/api/people/";
export const starshipsURL = "https://swapi.dev/api/starships/";
